import { required, email as emailRule, sameAs } from 'vuelidate/lib/validators'

export const userName = [
  {
    rule: required,
    msg: 'Name is required'
  }
]

export const name = [
  {
    rule: required,
    msg: 'Name is required'
  }
]

export const description = [
  {
    rule: required,
    msg: 'Description is required'
  }
]

export const configRules = [
  {
    rule: required,
    msg: 'Rules is required'
  },
  {
    async rule (value) {
      if (value === '') return false
      const response = await this.$store.dispatch('validateGNIPRule', value)
      const data = await response.data
      if (data.status !== 'SUCCESS' || !data.payload) {
        return false
      }
      return Boolean(await data.payload)
    },
    msg: 'GNIP Rule is not valid.'
  }
]

export const configNewsapi = [
  {
    rule: required,
    msg: 'News API is required'
  }
]

export const configDatabaseName = [
  {
    rule: required,
    msg: 'Database name is required'
  },
  {
    rule (value) {
      return /^[a-z_]*$/.test(value)
    },
    msg: 'Database name must only include lower case letters and underscores'
  }
]

export const firstName = [
  {
    rule: required,
    msg: 'First name is required'
  }
]

export const lastName = [
  {
    rule: required,
    msg: 'Last name is required'
  }
]

export const email = [
  {
    rule: required,
    msg: 'Email address is required'
  },
  {
    rule: emailRule,
    msg: 'Invalid email address'
  }
]

export const password = [
  {
    rule: required,
    msg: 'Password is required'
  },
  {
    rule (value) {
      return value && value.length >= 4
    },
    msg: 'Password requires at least 4 characters'
  }
]

export const confirmation = [
  {
    rule: required,
    msg: 'Confirmation is required'
  },
  {
    rule: sameAs('password'),
    msg: 'Password mismatch'
  }
]

export const importDbUrl = [
  {
    rule: required,
    msg: 'Database url is required'
  }
]

export const importDbUser = [
  {
    rule: required,
    msg: 'Database user is required'
  }
]

export const importDbPass = [
  {
    rule: required,
    msg: 'Database password is required'
  }
]

const vrules = (vdata) => {
  return vdata.reduce((acc, cur, i) => {
    acc[i] = cur.rule
    return acc
  }, {})
}

const vmsg = (validator, vdata) => {
  for (let i = 0; i < vdata.length; i++) {
    if (!validator[i]) { return vdata[i].msg }
  }
}

export default {
  vrules,
  vmsg
}



// WEBPACK FOOTER //
// ./src/helpers/validators.js